import React, {
  useEffect,
  createContext,
  useRef,
  useState,
  useContext,
} from 'react';
import { AuthContext } from './auth';
const { config } = require('util/constants');

// @ts-ignore
const MCFFormsContext = createContext();

function MCFFormsProvider(props) {
  const { user } = useContext(AuthContext);
  const [MCFForms, setMCFForms] = useState(null);
  const [partsPendingMentorReview, setPartsPendingMentorReview] = useState([]);
  const [partsPendingReview, setPartsPendingReview] = useState([]);
  const [partsPendingFab, setPartsPendingFab] = useState([]);
  const [partsFabCompleted, setPartsFabCompleted] = useState([]);

  const partCount = useRef({
    pendingMentorReview: 0,
    pendingReview: 0,
    pendingFab: 0,
    fabCompleted: 0,
  });
  const myPartCount = useRef({
    pendingMentorReview: 0,
    pendingReview: 0,
    pendingFab: 0,
    fabCompleted: 0,
  });

  const getMCFForms = callback => {
    fetch(`${config.API_URL}/transactions/getAllMCFForms`, {
      method: 'GET',
    })
      .then(response => response.json())
      .then(data => {
        typeof callback === 'function' && callback(data);

        const partsPendingMentorReview = data.filter(
          e => !e.mentorApproved && !e.approved && !e.manufactured
        );
        setPartsPendingMentorReview(partsPendingMentorReview);

        const partsPendingReview = data.filter(
          e => e.mentorApproved && !e.approved && !e.manufactured
        );
        setPartsPendingReview(partsPendingReview);

        const partsPendingFab = data.filter(
          e => e.mentorApproved && e.approved && !e.manufactured
        );
        setPartsPendingFab(partsPendingFab);
        const partsFabCompleted = data.filter(e => e.manufactured);
        setPartsFabCompleted(partsFabCompleted);

        partCount.current.pendingMentorReview = partsPendingMentorReview.length;
        partCount.current.pendingReview = partsPendingReview.length;
        partCount.current.pendingFab = partsPendingFab.length;
        partCount.current.fabCompleted = partsFabCompleted.length;

        myPartCount.current.pendingMentorReview =
          partsPendingMentorReview.filter(
            e => e.googleId === user.googleId
          ).length;

        myPartCount.current.pendingReview = partsPendingReview.filter(
          e => e.googleId === user.googleId
        ).length;

        myPartCount.current.pendingFab = partsPendingFab.filter(
          e => e.googleId === user.googleId
        ).length;
        myPartCount.current.fabCompleted = partsFabCompleted.filter(
          e => e.googleId === user.googleId
        ).length;

        setMCFForms(data);
      })
      .catch(err => {
        console.error(err);
      });
  };

  useEffect(() => {
    getMCFForms();
  }, []);

  return (
    <MCFFormsContext.Provider
      value={{
        MCFForms,
        getMCFForms,
        partCount,
        myPartCount,
        partsPendingMentorReview,
        partsPendingReview,
        partsPendingFab,
        partsFabCompleted,
      }}
      {...props}
    />
  );
}

export { MCFFormsContext, MCFFormsProvider };
